<template>
  <div class="about">
    <h1>Quiz</h1>
    <p class="text-center px-20">Respondendo ao quiz e acertando pelo menos 4 das 5 perguntas, você pode conquistar seu Certificado de Agente de Prevenção da Rede SARAH! Está preparado?</p>
    
    <div v-for="(questao, idx) in questoes" v-bind:key="questao.id">
      <div class="flex justify-center">
        <div class="my-10 relative">
          <img :src="questao.imgHeader" />
          <img :src="getNumberHeader(idx)" class="absolute number-header" />
          <h2>{{ questao.questao }}</h2>
        </div>
      </div>
      <div class="">
        <div v-for="resposta in questao.respostas" v-bind:key="resposta.id"
          class="inline-block m-1 p-3 rounded-lg cursor-pointer answer-box"
          :class="{ 'active': estaSelecionado(questao.id, resposta.id) }"
          @click="selecionarResposta(questao.id, resposta.id)">
          {{ resposta.texto }}
        </div>
      </div>
    </div>
    
    <br/>
    <br/>
    <br/>

    <div class="text-center">
      <button class="rounded-lg bg-red px-6 py-4 text-white" style="background-color: #F69E36; border-radius: 50px" @click="exibirResultado()">Ver Resultado</button>
    </div>

    <modal-certificado v-model:show="register" :qtd-acertos="qtdAcertos" @TENTE_NOVAMENTE="tentarNovamente()">
    </modal-certificado>
  </div>
</template>

<script>
import ModalCertificado from '../components/ModalCertificado.vue'
export default  {
  components: { ModalCertificado },
  data () {
    return {
      questoesRespondidas: {},
      questoes: [
        {
          id: 1,
          imgHeader: require('../assets/quiz/headers/Quizz_0001_sis-nervoso.png'),
          questao: 'O nosso sistema nervoso central é formado por:',
          respostas: ([
            { id: 1, texto: 'Cérebro e medula espinhal', correta: true },
            { id: 2, texto: 'Cérebro e coluna vertebral', correta: false },
            { id: 3, texto: 'Medula espinhal e coluna vertebral', correta: false },
            { id: 4, texto: 'Crânio e medula espinhal', correta: false },
          ]).sort(() => Math.random() - 0.5)
        },
        {
          id: 2,
          imgHeader: require('../assets/quiz/headers/Quizz_0002_cerebro.png'),
          questao: 'Onde fica o cérebro?',
          respostas: ([
            { id: 1, texto: 'Dentro da coluna cervical', correta: false },
            { id: 2, texto: 'Dentro da coluna vertebral', correta: false },
            { id: 3, texto: 'Na medula espinhal', correta: false },
            { id: 4, texto: 'Dentro do crânio', correta: true },
          ]).sort(() => Math.random() - 0.5)
        },
        {
          id: 3,
          imgHeader: require('../assets/quiz/headers/Quizz_0003_evitar-atropelamentos.png'),
          questao: 'Como podemos evitar um atropelamento?',
          respostas: ([
            { id: 1, texto: 'Atravessando a rua quando o sinal estiver verde para os veículos', correta: false },
            { id: 2, texto: 'Atravessando sempre em local seguro, utilizando a faixa de pedestres e quando possível, utilizando a passarela', correta: true },
            { id: 3, texto: 'Atravessar a rua em locais que não possuem sinalização ou por entre os carros', correta: false },
            { id: 4, texto: 'Atravessando a rua correndo', correta: false },
          ]).sort(() => Math.random() - 0.5)
        },
        {
          id: 4,
          imgHeader: require('../assets/quiz/headers/Quizz_0004_cinto-seg.png'),
          questao: 'Qual a principal importância de usar cinto de segurança?',
          respostas: ([
            { id: 1, texto: 'Evitar que a pessoa se movimente dentro do veículo em caso de colisão ou freada brusca ou mesmo que seja projetada para fora do veículo', correta: true },
            { id: 2, texto: 'Não pagar multa de trânsito', correta: false },
            { id: 3, texto: 'Evitar uma colisão do veículo', correta: false },
            { id: 4, texto: 'Obedecer o motorista do veículo', correta: false },
          ]).sort(() => Math.random() - 0.5)
        },
        {
          id: 5,
          imgHeader: require('../assets/quiz/headers/Quizz_0005_motorista.png'),
          questao: 'Dentro do veículo o motorista deve:',
          respostas: ([
            { id: 1, texto: 'Usar o celular e dirigir', correta: false },
            { id: 2, texto: 'Dirigir sem o cinto de segurança', correta: false },
            { id: 3, texto: 'Pedir aos passageiros para utilizarem o cinto de segurança', correta: true },
            { id: 4, texto: 'Beber e dirigir', correta: false },
          ]).sort(() => Math.random() - 0.5)
        }
      ],
      register: false,
      qtdAcertos: 0
    }
  },
  methods: {
    selecionarResposta(q, r) {
      this.questoesRespondidas[q] = r
    },
    getNumberHeader (number) {
      return require("../assets/quiz/" + (number + 1) + ".png")
      //return require(`../assets/quiz/${number}.png`)
    },
    estaSelecionado(q, r) {
      return this.questoesRespondidas[q] == r
    },
    exibirResultado() {
      this.qtdAcertos = this.getAcertos()
      this.register = true
    },
    getAcertos() {
      let acertos = 0
      Object.getOwnPropertyNames(this.questoesRespondidas).forEach((o) => {
        let questao = this.questoes.find(q => q.id == o)
        let resposta = questao.respostas.find(r => r.id == this.questoesRespondidas[o])
        if(resposta.correta) acertos++;
      })
      return acertos
    },
    tentarNovamente() {
      this.questoesRespondidas = {}
      this.$smoothScroll({
        scrollTo: 0,
        updateHistory: false
      })
    }
  },
  mounted () {
    this.$smoothScroll({
      scrollTo: 0,
      updateHistory: false
    })
  }
}
</script>

<style scoped>
.answer-box {
  width: 40%;
  box-shadow: rgb(0 0 0 / 29%) 0px 0px 8px 0px;
  background-color: white;
}

.active {
  background-color: #F69E36;
  color: white;
}

.number-header {
  left: -35px;
  top: 200px;
}

@media (max-width: 1200px) {
  .number-header {
    left: -20px;
    top: 0px;
    width: 50px;
  }
  .answer-box {
    width: 100%;
  }
}
.answer-box:hover {
  animation: shake .7s alternate 1;
  animation-timing-function: ease-out;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg) scale(1.1); }
  10% { transform: translate(-1px, -2px) rotate(-1deg) scale(1.2); }
  20% { transform: translate(-3px, 0px) rotate(1deg) scale(1.1); }
  30% { transform: translate(3px, 2px) rotate(0deg) scale(1); }
  40% { transform: translate(1px, -1px) rotate(1deg) scale(1); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}
.number-header {
  left: -35px;
  top: 200px;
}

@media (max-width: 1200px) {
  .number-header {
    left: -20px;
    top: 0px;
    width: 50px;
  }
  .answer-box {
    width: 100%;
  }
}

</style>